import { AlertCircle, Inbox } from "lucide-react";

import { Button } from "@/common/ui/button";

import { FeedbackTable } from "./FeedbackTable";
import { FeedbackToolbar } from "./FeedbackToolbar";
import { useFeedback } from "./use-feedback";

export function FeedbackPage(): React.ReactElement {
  const { feedback, isLoading, error, refresh, lastRefreshedAt } = useFeedback();

  return (
    <div data-testid="feedback-page" className="space-y-6">
      <FeedbackToolbar
        isLoading={isLoading}
        lastRefreshedAt={lastRefreshedAt}
        onRefresh={refresh}
      />

      {error && (
        <div
          data-testid="feedback-error"
          className="flex items-center gap-2 rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive"
        >
          <AlertCircle className="h-4 w-4 shrink-0" />
          <span>{error}</span>
          <Button
            data-testid="retry-button"
            variant="outline"
            size="sm"
            className="ml-auto"
            onClick={refresh}
          >
            Retry
          </Button>
        </div>
      )}

      {!isLoading && !error && feedback.length === 0 && (
        <div
          data-testid="feedback-empty"
          className="flex flex-col items-center justify-center gap-3 py-16 text-muted-foreground"
        >
          <Inbox className="h-12 w-12" />
          <p className="text-lg font-medium">No feedback yet</p>
          <p className="text-sm">Submitted feedback will appear here.</p>
        </div>
      )}

      {feedback.length > 0 && <FeedbackTable feedback={feedback} />}
    </div>
  );
}
